import { RequestOfferRequestRefundState } from './requestOfferRequestRefund.types'

const initialState: RequestOfferRequestRefundState = {
  loading: false,
  error: null,
  success: null
}

export default initialState
